.root {
  line-height: 1;
  padding: 10px;
}

.usersCardItem{
  margin-left: 10px
}
